import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { CapabilitySpec } from '../capability-spec'
import { CapabilitySpecDetailComponent } from '../capability-spec-detail/capability-spec-detail.component'

@Component({
  selector: 'app-capability-spec-detail-side',
  templateUrl: './capability-spec-detail-side.component.html',
  styleUrls: ['./capability-spec-detail-side.component.scss'],
  imports: [CapabilitySpecDetailComponent],
})
export class CapabilitySpecDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public capability: CapabilitySpec
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.capability = route.snapshot.data['capability']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
